// extracted by mini-css-extract-plugin
export default {"userInput":"render-user-input_userInput__3sSB8","input":"render-user-input_input__7jFQm","sendBtn":"render-user-input_sendBtn__KX-yG"};